import React from 'react'

export const ePaperLogo: React.FC = () => (
    <svg
        width="29"
        height="29"
        viewBox="0 0 35 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M17.1751 3.49853V26.1116C18.9219 24.6222 22.9979 22.591 26.6371 22.591C28.4927 22.591 30.4863 23.0678 32.0148 23.5655C32.9875 23.8822 34.0611 23.1803 34.0611 22.1574V3.56024C34.0611 2.95746 33.6875 2.39327 33.13 2.16416C31.9366 1.67376 29.7874 0.925781 26.6371 0.925781C22.3282 0.925781 18.5337 2.64095 17.1751 3.49853Z"
            fill="black"
        />
        <path
            d="M17.1751 3.49853V26.1116C18.9219 24.6222 22.9979 22.591 26.6371 22.591C28.4927 22.591 30.4863 23.0678 32.0148 23.5655C32.9875 23.8822 34.0611 23.1803 34.0611 22.1574V3.56024C34.0611 2.95746 33.6875 2.39327 33.13 2.16416C31.9366 1.67376 29.7874 0.925781 26.6371 0.925781C22.3282 0.925781 18.5337 2.64095 17.1751 3.49853Z"
            fill="white"
            fillOpacity="0.3"
        />
        <path
            d="M17.1751 3.49853V26.1116C15.4283 24.6222 11.3523 22.591 7.71307 22.591C5.85745 22.591 3.86384 23.0678 2.33532 23.5655C1.36266 23.8822 0.289062 23.1803 0.289062 22.1574V3.56024C0.289062 2.95746 0.662615 2.39327 1.22016 2.16416C2.41357 1.67376 4.5627 0.925781 7.71307 0.925781C12.0219 0.925781 15.8165 2.64095 17.1751 3.49853Z"
            fill="black"
        />
    </svg>
)
